import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useRef,
} from "react";
import { useMyLearning } from "../../context";
import { useFilterProviderSyncEffects } from "./useFilterProviderSyncEffects";
import { useMyLearningFilterHandlers } from "./useMyLearningFilterHandlers";
import { useMyLearningFilterUrlSync } from "./useMyLearningFilterUrlSync";

const FilterContext = createContext();

export const useFilter = () => useContext(FilterContext);

export const FilterProvider = ({ children, mode }) => {
  const {
    filter: contextFilter,
    fetchMyLearningData,
    applyFilter,
    setStatus,
    setSortBy: setContextSortBy,
    courses,
    programs,
    filteredCourses,
    filteredPrograms,
    searching,
    categories,
    tags,
  } = useMyLearning();

  const [state, setState] = useState({
    filter: {
      ...contextFilter,
      drawerOpen: false,
    },
    hitCount: 0,
    totalCount: 0,
  });

  const contextFilterRef = useRef(contextFilter);
  contextFilterRef.current = contextFilter;

  const updateState = useCallback((updates) => {
    if (typeof updates === "function") {
      setState((prevState) => ({
        ...prevState,
        ...updates(prevState),
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        ...updates,
      }));
    }
  }, []);

  useFilterProviderSyncEffects({
    updateState,
    contextFilter,
    courses,
    programs,
    filteredCourses,
    filteredPrograms,
    searching,
  });

  const handlers = useMyLearningFilterHandlers({
    updateState,
    state,
    contextFilter,
    mode,
    fetchMyLearningData,
    applyFilter,
    setStatus,
    setContextSortBy,
  });

  useMyLearningFilterUrlSync({
    mode,
    courses,
    programs,
    searching,
    tags,
    categories,
    contextFilter,
    contextFilterRef,
    fetchMyLearningData,
    applyFilter,
    updateState,
    setTagFilter: handlers.setTagFilter,
  });

  const value = {
    state: state.filter,
    setState: (updates) => {
      if (typeof updates === "function") {
        updateState((prevState) => ({
          filter: updates(prevState.filter),
        }));
      } else {
        updateState({ filter: updates });
      }
    },
    hitCount: state.hitCount,
    totaltCount: state.totalCount,
    showHitCount: state.totalCount !== state.hitCount,
    ...handlers,
    mode,
  };

  return (
    <FilterContext.Provider value={value}>{children}</FilterContext.Provider>
  );
};

export default FilterProvider;
